import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { FileDown } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function DataExport() {
  const token = localStorage.getItem('vendor_token');
  const download = (endpoint) => window.open(`${API}/api/lis/business/${endpoint}?token=${token}`, '_blank');

  // Need to use fetch with auth header for protected endpoints
  const downloadCSV = async (endpoint, filename) => {
    const res = await fetch(`${API}/api/lis/business/${endpoint}`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = filename; a.click();
    URL.revokeObjectURL(url);
  };

  const exports = [
    { label: 'Bills', desc: 'All bills with patient, test, and payment details', endpoint: 'export/bills', file: 'bills_export.csv' },
    { label: 'Tests', desc: 'Complete test rate list with B2B prices', endpoint: 'export/tests', file: 'tests_export.csv' },
    { label: 'Panels', desc: 'Panels and packages with included tests', endpoint: 'export/panels', file: 'panels_export.csv' },
    { label: 'Patients', desc: 'Patient registry with demographics', endpoint: 'export/patients', file: 'patients_export.csv' },
  ];

  const templates = [
    { label: 'Tests CSV Template', desc: 'Sample CSV format for bulk test upload', endpoint: 'templates/tests', file: 'tests_template.csv' },
    { label: 'Panels CSV Template', desc: 'Sample CSV format for bulk panel upload', endpoint: 'templates/panels', file: 'panels_template.csv' },
  ];

  return (
    <div data-testid="lis-data-export">
      <h1 className="text-xl font-bold text-slate-800 mb-4">Data Export</h1>
      <h2 className="text-sm font-semibold text-slate-600 mb-3">Export Data as CSV</h2>
      <div className="grid gap-3 md:grid-cols-2 mb-6">
        {exports.map(e => (
          <Card key={e.label} className="border-slate-200"><CardContent className="p-4 flex items-center justify-between">
            <div><p className="font-medium text-sm">{e.label}</p><p className="text-xs text-slate-500">{e.desc}</p></div>
            <Button variant="outline" size="sm" onClick={() => downloadCSV(e.endpoint, e.file)}><FileDown className="w-3.5 h-3.5 mr-1" /> Download</Button>
          </CardContent></Card>
        ))}
      </div>
      <h2 className="text-sm font-semibold text-slate-600 mb-3">CSV Templates for Bulk Upload</h2>
      <div className="grid gap-3 md:grid-cols-2">
        {templates.map(t => (
          <Card key={t.label} className="border-slate-200"><CardContent className="p-4 flex items-center justify-between">
            <div><p className="font-medium text-sm">{t.label}</p><p className="text-xs text-slate-500">{t.desc}</p></div>
            <Button variant="outline" size="sm" onClick={() => downloadCSV(t.endpoint, t.file)}><FileDown className="w-3.5 h-3.5 mr-1" /> Download</Button>
          </CardContent></Card>
        ))}
      </div>
    </div>
  );
}
